import React from 'react';

import { Box, CardContent, CardMedia, Typography } from '@mui/material';

import { CheckCircle } from '@mui/icons-material';

import { Link } from 'react-router-dom';

import { demoProfilePicture, demoChannelUrl, demoChannelTitle } from '../utils/constants';

const ChannelCard = ({ channelDetail:{ id: {
  channelId }, snippet } }) => { 

    
  console.log('hi');
  console.log(channelId, snippet);

  const ChannelCard = 
            {
                src: snippet.thumbnails.medium.url,
                title: snippet.title,
                channelTitle: snippet.channelTitle
            }

   return (

    <Box sx={{
      boxShadow: 'none',
      borderRadius: '20px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: { xs: '100%', md: '400px' }
    }}> 
      {/* <Link to={channelId ? `/channel/${channelId}` : channelId}> */}
      <Link to={channelId ? `/channel/${channelId}` : demoChannelUrl}>
        <CardContent sx={{ display:'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', color: '#fff' }}>
          <CardMedia>
            <img style={{ width: '180px', height: '180px', borderRadius: '50%', marginBottom: 10, border: '1px solid #e3e3e3' }} src={ChannelCard.src} alt={ChannelCard.channelTitle} />
            <Link>
              <Typography variant='h6' fontWeight='bold' color='#fff'>
                {ChannelCard.title.slice(0, 30) || demoChannelTitle.slice(0, 30) }
                <CheckCircle sx={{ fontSize: 12, ml: '5px', color: 'gray' }} />
              </Typography>
            </Link>
          </CardMedia>
        </CardContent>
      </Link>
    </Box>
  )

}

export default ChannelCard